import { CloudDownload } from 'lucide-react';
import React from 'react';
import * as XLSX from 'xlsx';

interface ExportExcelProps {
    data: any[];
    filename: string;
    onDownloadError: (errorMessage: string) => void;
}

const ExportExcel = ({ data, filename, onDownloadError }: ExportExcelProps) => {
    const handleExport = () => {
        if (data.length === 0) {
            onDownloadError('No data to export');
            return;
        }

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, filename);
        XLSX.writeFile(wb, `${filename}-${new Date().toISOString()}.xlsx`);   


        // const headerRow = columns.map((column) => column.header);
        // const dataRow = columns.map((column) => column.accessorKey);
        
        // const newData = data.map((item: any) => {
        //     const row: any = {};
        //     headerRow.forEach((key: any, index: number) => {
        //         row[key] = item[dataRow[index]];
        //     });
        //     return row;
        // });


        // // i want the header row to be the first row
        // const ws = XLSX.utils.json_to_sheet([...newData]);
        // const wb = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Brands');
        // XLSX.writeFile(wb, `${filename}.xlsx`);
    };

    return (
        <button type="button"
                                        className="text-white btn bg-green-500 border-green-500 hover:text-white hover:bg-green-600 hover:border-green-600 focus:text-white focus:bg-green-600 focus:border-green-600 focus:ring focus:ring-green-100 active:text-white active:bg-green-600 active:border-green-600 active:ring active:ring-green-100 dark:ring-green-400/20 ml-2"
                                        onClick={() => {
                                           handleExport();
                                        }}>
                                        <CloudDownload className="inline-block size-4" />
                                        <span className="align-middle">Download Excel</span>
                                    </button>
    );
};

export default ExportExcel;